export function showPersonCompetitionAward(result, personId) {
    if (!personId)
        return true;
    const { registration: reg } = result;
    if (reg.vaultingLungerPerson?.id == personId) {
        return reg.athletes.some(x => x.id == personId);
    }
    return true;
}
